<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <AppSidebar />
      <main class="main">
        <div class="container-fluid pt-3">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { redirectIfNotGrantedByRole } from '@/helpers'
import AppHeader from '@/components/Header'
import AppSidebar from '@/components/Sidebar'

export default {
  name: 'MahasiswaLayout',
  components: {
    AppHeader,
    AppSidebar
  },
  computed: mapGetters('users', { userDetail: 'getUserDetail' }),
  beforeRouteEnter (to, from, next) {
    next(redirectIfNotGrantedByRole('mahasiswa', { name: 'main' }))
  }
}
</script>
